<template>
    <div id="description-basicas">
        <div class="description-title" @click="showDescription = !showDescription">
            <span>Saiba mais sobre as camisetas básicas da Chico Rei</span>
            <span class="toggle-description">{{
                showDescription ? '(ocultar)' : '(mostrar)'
            }}</span>
        </div>
        <div class="description-content my-4" :class="{ visible: showDescription }">
            <h1 class="my-0">Sua próxima camiseta básica favorita está aqui!</h1>
            <div class="my-3">
                <p class="my-3">
                    Versátil, confortável e ideal para os mais diversos momentos, a camiseta básica
                    é uma peça indispensável para qualquer guarda-roupa! Além de combinar com os
                    mais diferentes estilos, ela também pode ser usada da reunião de trabalho ao
                    encontro com os amigos, sendo uma companheira fiel faça chuva ou faça sol.
                </p>
                <p class="my-3">
                    Por aqui, essa peça clássica conta com várias cores e uma ampla variedade de
                    tamanhos, que vão do PP ao 4GG. Nós partimos da ideia de que você não precisa se
                    ajustar para caber em uma roupa e sim que a roupa precisa se adaptar ao seu
                    corpo. É por isso que nosso Guia de Tamanhos conta com opções plurais, para te
                    ajudar a carregar toda a sua boniteza de ser por aí, sem deixar o conforto de
                    lado.
                </p>
            </div>
            <h2 class="my-0">Camisetas 100% algodão: conforto e estilo em uma só peça</h2>
            <div class="my-3">
                <p class="my-3">
                    Mais do que uma camiseta confortável, uma peça que te abraça! A gente descobriu
                    que as camisetas têm o poder de abraçar e, por aqui, elas cumprem essa missão
                    com estilo, isso porque nossas queridas camisetas básicas são feitas com fios
                    100% naturais de algodão sustentável, vindos diretamente das plantações do
                    nordeste brasileiro. Uma boniteza única que chega até aqui e vai diretamente
                    para nossa fábrica!
                </p>
                <p class="my-3">
                    Antes da camiseta ser produzida, a malha fica descansando por, pelo menos, 24h
                    na mesa de corte, onde ocorre o encolhimento natural das fibras. Isso evita que
                    a camiseta encolha após a lavagem ou com o passar do tempo.Do lado de cá, a
                    gente se preocupa com cada etapa da produção, garantindo a qualidade de cada
                    peça.
                </p>
                <p class="my-3">
                    Por último, mas não menos importante, as nossas camisetas recebem o selo de
                    sustentabilidade Better Cotton Initiative, certificando não apenas a qualidade
                    do nosso algodão, como também o compromisso que temos com o meio ambiente.
                </p>
            </div>

            <h2 class="my-0">Camisetas básicas para todos os gostos</h2>
            <div class="my-3">
                <p class="my-2">
                    Aqui na Chico Rei você encontra a camiseta básica ideal para todas as situações,
                    pois elas passeiam pelos mais diversos tons, dos neutros aos mais vibrantes.
                    Além disso, você também pode criar combinações cheias de personalidade e que
                    combinem com o seu estilo. Confira algumas opções de peças para compor o visual:
                </p>
                <h3 class="my-1">Bermudas</h3>
                <p class="my-2">
                    As bermudas têm ganhado cada vez mais espaço nas tendências de moda e estão
                    provando que vieram para ficar. Além de ser uma peça confortável, elas também
                    têm o poder de deixar o look mais estiloso, com um toque despojado que faz toda
                    a diferença. Por aqui, você encontra bermudas em diferentes cores, tamanhos e
                    tecidos! Confira todos os modelos em nossa página.
                </p>
                <h3 class="my-1">Calças</h3>
                <p class="my-2">
                    Essencial em qualquer guarda-roupa, a calça é uma peça que está presente nos
                    mais diferentes estilos e conta com uma ampla variedade de modelos. Por aqui,
                    ela chega na modelagem Paper Bag, feita 100% de algodão e disponível em 3 cores:
                    caqui, preto e marrom. A peça perfeita para combinar com sua camiseta básica.
                </p>
                <h3 class="my-1">Shoulder Bags e Pochetes</h3>
                <p class="my-2">
                    É impossível falar sobre composição de look sem mencionar os tão queridos
                    acessórios que fazem toda a diferença no visual. Um exemplo disso são as
                    pochetes e shoulder bags que têm o poder de deixar qualquer combinação mais
                    estilosa e estão disponíveis na nossa seleção de bolsas.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DescriptionBasicas',
        data() {
            return {
                showDescription: false,
            };
        },
    };
</script>
